import React, { useState } from "react";
import { useSelector } from "react-redux";
import { t } from "i18next";
import { useParams } from "react-router-dom";
import { useLang, useUserWallet } from "hooks";
import useCurrentUser from "hooks/useCurrentUser";
import AddUserInfoForm from "components/Modals/AddUserInfoForm";
import { OrderHistoryIcon, WalletBalanceIcon, LogoutIcon } from "./SettingsIcons";
import { DownArrow } from "config/Svgs";
import LanguageToggler from "features/LanguageToggler";
import { PriceRender } from "components/DisplayPrice";

const defaultFn = () => {};

export const SettingLinksN = ({ handleAllOrders = defaultFn, handleLogout = defaultFn, handleEditProfile = defaultFn }) => {
  const userWallet = useUserWallet();
  const { currentUser } = useCurrentUser();
  const { brandInfo } = useSelector((state) => state.brandStorageReducer);

  const userLinks = [
    {
      label: t("Order History"),
      onClick: handleAllOrders,
      icon: <OrderHistoryIcon />,
      showNavIcon:true,
      isVisible: true
    },
    {
      label: t("Wallet Balance"),
      displayValue: <PriceRender price={userWallet} />,
      className:"pointer-events-none",
      isVisible: /*Number(userWallet) > 0*/ true,
      onClick: () => {},
      icon: <WalletBalanceIcon />
    },
    {
      label: t("Logout"),
      onClick: handleLogout,
      icon: <LogoutIcon />,
      isVisible: true
    },
  ];

  return (
    <div className="settings-linkn-container flex flex-col items-center gap-8 min-h-screen">
      {/* user profile and Name */}
      <div className="flex gap-3 items-center w-full mb-8">
        <div className="rounded-16x w-20 h-20">
          <img src={brandInfo?.setting?.brandLogoFirst} alt={brandInfo?.brand?.brandName} className="w-full h-full object-cover" />
        </div>
        <div>
          <h2 className="m-0 text-24x font-semibold text-dark-blue-900]">{t(currentUser?.user?.name ?? brandInfo?.brand?.brandName)}</h2>
          <button className="m-0 text-14x text-brand-base-primary cursor-pointer outline-none border-none" onClick={handleEditProfile}>
            {t("Edit Profile")}
          </button>
        </div>
      </div>
      {/* user links */}
      {userLinks?.map((link, index) => (
        <button key={index} className={`items-center justify-between w-full gap-2 outline-none border-none ${link?.isVisible ? "flex": "hidden invisible"} ${link?.className || ""}`} onClick={link.onClick}>
          <div className="flex items-center gap-2">
            {link?.icon}
            <p className="text-16x text-dark-blue-900 font-medium m-0">{link?.label}</p>
            {
              link?.displayValue ? link?.displayValue : null
            }
          </div>
          {link?.showNavIcon && (
            <div onClick={link.onClick}>
             <DownArrow />
             </div>
          )}
        </button>
      ))}
      <div className="w-full flex justify-start">
      <LanguageToggler className="bg-dark-blue-100" />
      </div>
    </div>
  );
};